export default {
    todasReavaliacoes: {
        filtros: {
            conteudo: {
                value: null,
                default: null,
                label: 'Pesquisa'
            }
        },
        paginacao: {
            page: 1,
            rowsPerPage: 10,
            sortBy: ['numero'],
            defaultSortBy: ['numero'],
            sortDesc: [false]
        }
    }
}
